import React from 'react';
import { Button } from '@/components/forms/ui/button';

type ActivityExpandToggleProps = {
  expanded: boolean;
  onToggle: () => void;
  collapsedLabel: string;
  expandedLabel: string;
};

export function ActivityExpandToggle({
  expanded,
  onToggle,
  collapsedLabel,
  expandedLabel
}: ActivityExpandToggleProps) {
  return (
    <Button variant="ghost" size="sm" className="h-auto px-0 py-0.5 text-xs" onClick={onToggle}>
      {expanded ? expandedLabel : collapsedLabel}
    </Button>
  );
}
